<template>
  <div class="box_down">
    <div class="top_img_box">
      <div :style="{ height: isMobile ? '187px' : '400px' }" class="top_box">
        <!-- <div class="down_box"> -->
        <div :class="['download_num',isMobile ? 'img_mobile':'']">
          <img class="l_img" src="@/assets/register/nums.png" alt="" srcset="">
          <img class="num_img" src="@/assets/register/1.png" alt="" srcset="">
          <img class="num_img" src="@/assets/register/0.png" alt="" srcset="">
          <img class="num_img" src="@/assets/register/0.png" alt="" srcset="">
          <img class="w_img" src="@/assets/register/w.png" alt="" srcset="">
          <img class="per_img" src="@/assets/register/per.png" alt="" srcset="">
          <div class="jia">+</div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <div class="bh_serve">
      <div class="line_box">
        <div class="line" />
        <div class="squire_box" />
      </div>
      <div :style="{ fontSize: isMobile ? '20px' : '40px' }" class="bh_word">
        冰火手游服务特色
      </div>
      <div class="line_box">
        <div class="squire_box" />
        <div class="line" />
      </div>
    </div>
    <div class="item_box" :style="{ fontSize: isMobile ? '12px' : '16px',padding: isMobile ? '0 10px' : '0 20px' }">
      <div class="item" :style="{ paddingBottom: isMobile ? '7px' : '15px' }">
        <div class="item_top" :style="{ padding: isMobile ? '5px 0' : '10px 0' }">
          <div class="item_line" />
          <div class="item_top_text">特色</div>
          <div class="item_sort">1</div>
          <div class="item_line" />
        </div>
        <div class="item_desc" :style="{ marginTop: isMobile ? '7px' : '15px' }">免费首充
        </div>
        <div class="item_desc" :style="{ marginTop: isMobile ? '7px' : '15px' }">超多福利，一秒到账
        </div>
      </div>

      <div class="item" :style="{ paddingBottom: isMobile ? '7px' : '15px' }">
        <div class="item_top" :style="{ padding: isMobile ? '5px 0' : '10px 0' }">
          <div class="item_line" />
          <div class="item_top_text">特色</div>
          <div class="item_sort">2</div>
          <div class="item_line" />
        </div>
        <div class="item_desc" :style="{ marginTop: isMobile ? '7px' : '15px' }">上线送VIP
        </div>
        <div class="item_desc" :style="{ marginTop: isMobile ? '7px' : '15px' }">无线元宝，超高爆率
        </div>
      </div>

      <div class="item" :style="{ paddingBottom: isMobile ? '7px' : '15px' }">
        <div class="item_top" :style="{ padding: isMobile ? '5px 0' : '10px 0' }">
          <div class="item_line" />
          <div class="item_top_text">特色</div>
          <div class="item_sort">3</div>
          <div class="item_line" />
        </div>
        <div class="item_desc" :style="{ marginTop: isMobile ? '7px' : '15px' }">无线畅玩
        </div>
        <div class="item_desc" :style="{ marginTop: isMobile ? '7px' : '15px' }">官服品质，变态服体验
        </div>
      </div>
    </div>
    <div class="login-container" :style="classStyle">
      <el-tabs v-model="activeName" stretch @tab-click="handleClick">
        <el-tab-pane label="手机注册" name="first">
          <el-form ref="phoneRegForm" :model="phoneRegForm" :rules="phoneRegRule" label-width="0px">
            <div class="inputs">
              <el-form-item prop="phone" class="input" label="">
                <el-input v-model="phoneRegForm.phone" maxlength="11" type="text" placeholder="请输入手机号码"
                  oninput="value=value.replace(/[^\d]/g,'')">
                  <i slot="prefix" class="el-input__icon el-icon-mobile-phone" />
                </el-input>
              </el-form-item>
            </div>
            <div class="inputs input3" style="display: flex">
              <el-form-item prop="sms" class="input1" label="">
                <el-input v-model="phoneRegForm.sms" type="text" placeholder="输入验证码"
                  oninput="value=value.replace(/[^\d]/g,'')">
                  <i slot="prefix" class="el-input__icon el-icon-folder-checked" />

                </el-input>
              </el-form-item>
              <el-button style="margin-left: 10px;margin-top: 4px;" :disabled="disable"
                :class="{ codeGeting: isGeting }" @click="getVerifyCode">{{ getCode }}
              </el-button>
            </div>
            <el-form-item label="" prop="password">
              <el-input v-model="phoneRegForm.password" placeholder="请输入密码" show-password>
                <i slot="prefix" class="el-input__icon el-icon-unlock" />
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="repassword">
              <el-input v-model="phoneRegForm.repassword" placeholder="请输入确认密码" show-password>
                <i slot="prefix" class="el-input__icon el-icon-unlock" />
              </el-input>
            </el-form-item>
            <el-form-item style="margin-left: 0;">
              <el-button type="primary" @click="onPhoneSubmit">提交
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="普通注册" name="second">
          <el-form ref="ordinaryRegForm" :model="ordinaryRegForm" :rules="ordinaryRegRule" label-width="0px">
            <el-form-item label="" prop="username">
              <el-input v-model="ordinaryRegForm.username" placeholder="请输入用户名">
                <i slot="prefix" class="el-input__icon el-icon-user-solid" />
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="password">
              <el-input v-model="ordinaryRegForm.password" placeholder="请输入密码" show-password>
                <i slot="prefix" class="el-input__icon el-icon-unlock" />
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="repassword">
              <el-input v-model="ordinaryRegForm.repassword" placeholder="请输入确认密码" show-password>
                <i slot="prefix" class="el-input__icon el-icon-unlock" />
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onOrdinarySubmit">提交
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div class="register_tip">
        注册账号成功后自动跳转{{type==3||type==2?'游戏':type==4?'折上折盒子app':type==1?'盒子app':'真香盒子app'}}下载页面，请耐心等待</div>
    </div>
    <div class="wx_qq_box" v-if="qqWx">
      <img class="wx_img" src="@/assets/android.png" alt="" srcset="">
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" :center='true' :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false" width="300px">
      <div style="text-align: center;color: red;">此渠道不可注册</div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    PromoteGeneralReg,
    PromotePhoneReg,
    yzm,
    check_register_page
  } from '@/api/user'
  import {
    sendSms,
  } from "@/api/my";
  // import { transform } from "jest.config";

  export default {
    name: 'BoxRegister',
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else {
          if (this[this.activeForm].repassword !== '') {
            this.$refs[this.activeForm].validateField('repassword')
          }
          callback()
        }
      }
      var validateRePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this[this.activeForm].password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      var code = (rule, value, callback) => {
        if (value === '') {
          return callback(new Error('请输入验证码'))
        } else if (value.length !== 6) {
          return callback(new Error('输入正确6位验证码'))
        } else {
          return callback()
        }
      }
      var telCheck = (rule, value, callback) => {
        var reg = /^1[3-9]\d{9}$/
        if (value === '') {
          return callback(new Error('请输入手机号码'))
        } else if (value.toString().length !== 11) {
          return callback(new Error('手机号码必须是11位数字'))
        } else if (!reg.test(value)) {
          return callback(new Error('请输入有效的手机号码'))
        } else {
          callback()
        }
      }
      return {
        activeName: 'first',
        activeForm: 'phoneRegForm',
        device: /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) ?
          'mobile' : 'pc',
        ordinaryRegForm: {
          username: '',
          password: '',
          repassword: '',
          promote_id: this.$route.query.promote_id
        },
        getCode: '获取验证码',
        isGeting: false,
        count: 60,
        disable: false,
        phoneRegForm: {
          phone: '',
          sms: '',
          password: '',
          repassword: '',
          promote_id: this.$route.query.promote_id
        },
        type: '',
        ordinaryRegRule: {
          username: [{
              required: true,
              message: '请输入账号名称',
              trigger: 'blur'
            },
            {
              min: 3,
              message: '用户名长度不小于3',
              trigger: 'blur'
            }
          ],
          password: [{
            validator: validatePass,
            trigger: 'blur'
          }],
          repassword: [{
            validator: validateRePass,
            trigger: 'blur'
          }]
        },
        phoneRegRule: {
          phone: [{
            validator: telCheck,
            trigger: 'blur'
          }],
          sms: [{
            validator: code,
            trigger: 'blur'
          }],
          password: [{
            validator: validatePass,
            trigger: 'blur'
          }],
          repassword: [{
            validator: validateRePass,
            trigger: 'blur'
          }]
        },
        gid: '',
        qqWx: false,
        dialogVisible: false
      }
    },
    computed: {
      classStyle() {
        var width = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
            navigator.userAgent
          ) ?
          '100%' :
          '50%'
        const height = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
            navigator.userAgent
          ) ?
          'auto' :
          '384px'
        return 'width:100%' + ';min-height:' + height
      },
      labelPosition() {
        return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) ?
          'top' :
          'right'
      },
      isMobile() {
        return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
      }
    },
    beforeCreate() {

    },
    mounted() {
      this.type = this.$route.query.type
      if (this.$route.query.type == 2 || this.$route.query.type == 3) {
        this.gid = this.$route.query.gid
      }

      let status = navigator.userAgent.toLowerCase()
      if (status.match(/MicroMessenger/i) == "micromessenger") {
        this.qqWx = true
      } else {
        this.qqWx = false
      }
      this.checkDisabled()
    },
    methods: {
      checkDisabled() {
        check_register_page({
          promote_id: this.$route.query.promote_id
        }).then(res => {
          if (res.code == 200) {
            this.dialogVisible = true
          }
        })
      },
      onOrdinarySubmit() {
        this.$refs['ordinaryRegForm'].validate((valid) => {
          if (valid) {
            PromoteGeneralReg(this.ordinaryRegForm).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: '注册成功',
                  type: 'success'
                })
                this.$refs['ordinaryRegForm'].resetFields()
                // 跳转下载链接
                const promoteId = this.$route.query.promote_id
                var isiOS = !!navigator.userAgent.match(
                  /\(i[^;]+;( U;)? CPU.+Mac OS X/
                )
                if (isiOS) {
                  if (this.type === '1') {
                    window.location.href =
                      'http://app.39bh.com/?promote_id=' + promoteId
                  } else if (this.type === '2' || this.type === '3') {
                    window.location.href =
                      `https://www.39bh.com/mobile/Downfile/index?gid=${this.gid}&pid=${promoteId}&template=2`
                  } else if (this.type === '4') {
                    window.location.href = 'http://zsz.39bh.cc/?promote_id=' + promoteId
                  } else {
                    window.location.href =
                      'http://01yx.39bh.cc/?promote_id=' + promoteId
                  }
                } else {
                  let url = 'http://01yx.39bh.cc/?promote_id=' + promoteId
                  if (this.type === '1') {
                    url = 'http://app.39bh.com/?promote_id=' + promoteId
                  } else if (this.type === '2' || this.type === '3') {
                    url =
                      `https://www.39bh.com/mobile/Downfile/index?gid=${this.gid}&pid=${promoteId}&template=2`
                  } else if (this.type === '4') {
                    url = 'http://zsz.39bh.cc/?promote_id=' + promoteId
                  }
                  window.open(url, '_blank')
                }
              }

            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      handleClick(tab, event) {
        if (tab.name === 'second') {
          this.activeForm = 'ordinaryRegForm'
        } else {
          this.activeForm = 'phoneRegForm'
        }
      },
      getVerifyCode() {
        if (this.phoneRegForm.phone) {
          sendSms({
            type: 'register',
            mobile_phone: this.phoneRegForm.phone
          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success"
              });
              var countDown = setInterval(() => {
                if (this.count < 1) {
                  this.isGeting = false
                  this.disable = false
                  this.getCode = '获取验证码'
                  this.count = 60
                  clearInterval(countDown)
                } else {
                  this.isGeting = true
                  this.disable = true
                  this.getCode = this.count-- + 's后重发'
                }
              }, 1000)
            }

          })
        } else {
          this.$message({
            message: '请先输入手机号',
            type: 'error'
          })
        }
      },
      onPhoneSubmit() {
        this.$refs['phoneRegForm'].validate((valid) => {
          if (valid) {
            PromotePhoneReg(this.phoneRegForm).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: '注册成功',
                  type: 'success'
                })
                this.$refs['phoneRegForm'].resetFields()
                // 跳转下载链接
                // http://www.39bh.com/mobile/downfile/download_app/promote_id/16
                const promoteId = this.$route.query.promote_id
                var isiOS = !!navigator.userAgent.match(
                  /\(i[^;]+;( U;)? CPU.+Mac OS X/
                )
                if (isiOS) {

                  if (this.type === '1') {
                    window.location.href =
                      'http://app.39bh.com/?promote_id=' + promoteId
                  } else if (this.type === '2' || this.type === '3') {
                    window.location.href =
                      `https://www.39bh.com/mobile/Downfile/index?gid=${this.gid}&pid=${promoteId}&template=2`
                  } else if (this.type === '4') {
                    window.location.href = 'http://zsz.39bh.cc/?promote_id=' + promoteId
                  } else {
                    window.location.href =
                      'http://01yx.39bh.cc/?promote_id=' + promoteId
                  }
                } else {
                  let url = 'http://01yx.39bh.cc/?promote_id=' + promoteId
                  if (this.type === '1') {
                    url = 'http://app.39bh.com/?promote_id=' + promoteId
                  } else if (this.type === '2' || this.type === '3') {
                    url =
                      `https://www.39bh.com/mobile/Downfile/index?gid=${this.gid}&pid=${promoteId}&template=2`
                  } else if (this.type === '4') {
                    url = 'http://zsz.39bh.cc/?promote_id=' + promoteId
                  }
                  window.open(url, '_blank')
                }
              }


            })
          }
        })
      }
    }
  }
</script>

<style scoped>
  .codeGeting {
    background: #ffffff;
    border-color: #cdcdcd;
  }

  /deep/ .el-tabs__nav-scroll {
    width: 50% !important;
    margin: 0 auto !important;
  }

  /* ::v-deep .el-tabs__item{
  color: white;
}
::v-deep .is-active{
  color: #1890ff;;
}
::v-deep .el-form-item__label{
  color: #1890ff;
}
::v-deep .el-input__inner{
  background: transparent;
  color: white;
} */
  .el-form-item {
    text-align: center;
    padding: 0 10vw;
  }

  .input3 {
    padding-right: 10vw;
  }

  .input3 .el-form-item {
    padding-right: 0;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }

  .box_down {
    /* background-color: #29D89450;

  background-image: url('~@/assets/register/bg3.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
  overflow: hidden; */
  }

  .top_box {
    background: #6f2acb;
    background-image: url("http://bhres.39bh.com/promote_zs_static/bg_top.png");
    background-size: 100% 100%;
    height: 400px;
    position: relative;
    width: 880px;
  }

  .top_img_box {
    background: #6f2acb;
    display: flex;
    justify-content: center;
  }

  .login-container {
    background-color: #ffffff30;
    /* border:2px solid #DCDFE6; */
    text-align: left;
    border-radius: 8px;
    margin: 0 auto;
    /* padding: 20px 40px; */
  }

  .register_tip {
    color: red;
    text-align: center;
    margin-bottom: 34px;
    font-size: 14px;
  }

  .bh_serve {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
  }

  .line_box {
    display: flex;
    align-items: center;
    position: relative;
  }

  .line {
    width: 20vw;
    height: 2px;
    background: #cdcdcd;
  }

  .squire_box {
    width: 15px;
    height: 15px;
    border: 2px solid #cdcdcd;
    transform: rotate(45deg);
  }

  .bh_word {
    font-size: 20px;
    font-weight: bold;
    margin: 0 10px;
  }

  .down_box {
    background: #6f2acb;
    position: absolute;
    bottom: 10px;
    left: 10px;
    /* padding: 15px 0; */
  }

  .download_num {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    background: #6f2acb;
    transform: scale(1);
    position: absolute;
    bottom: 10px;
    left: 10px;
  }

  .img_mobile .l_img {
    width: 73px;
    height: 20px;
  }

  .img_mobile .num_img {
    width: 19px;
    height: 25px;
  }

  .img_mobile .w_img {
    width: 19px;
    height: 18px;
  }

  .img_mobile .per_img {
    width: 35px;
    height: 19px;
  }

  .img_mobile .jia {
    position: relative;
    color: white;
    font-size: 24px;
    height: 20px;
    line-height: 20px;
    text-shadow: 2px 2px 5px #000;
  }

  .l_img {
    width: 183px;
    height: 50px;
  }

  .num_img {
    width: 48px;
    height: 64px;
  }

  .w_img {
    width: 48px;
    height: 46px;
  }

  .per_img {
    width: 89px;
    height: 49px;
  }

  .jia {
    position: relative;
    color: white;
    font-size: 60px;
    height: 50px;
    line-height: 50px;
    text-shadow: 2px 2px 5px #000;
  }

  .item_box {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    margin-top: 15px;
  }

  .item {
    width: 30vw;
    border: 1px solid #f9594d;
    border-radius: 10px;
    background: #f9594d;
    padding-bottom: 15px;
  }

  .item_top {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    color: #f9594d;
    border-radius: 10px 10px 0 0;
    background: white;
  }

  .item_line {
    width: 5vw;
    height: 1px;
    background: #f9594d;
  }

  .item_top_text {
    font-weight: bolder;
    margin-left: 5px;
  }

  .item_sort {
    border-radius: 50%;
    border: 1px solid #f9594d;
    color: #f9594d;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    margin-right: 5px;
    font-weight: bolder;
  }

  .item_desc {
    text-align: center;
    color: white;
    margin-top: 15px;
  }

  .slot_icon {
    width: 21px;
    height: 24px;
    margin-left: 5px;
    /* line-height: 30px;
  background: url("~@/assets/register/icon-lock.png") no-repeat center 0;
  background-size: auto 25px; */
    margin-top: 6px;
  }

  /deep/ .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }

  .wx_qq_box {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    z-index: 999;
  }

  .wx_img {

    max-width: 100%;
    /* 图片最大宽度为100% */
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/down/index.vue